import LargHotDrink from './large';
import MediumHotDrink from './medium';
import SmallHotDrink from './small';
import XLargeHotDrink from './x-large';

/**
 * Temporary solution until we figure out how we wanna handle these in sanity.
 */
const OrderedHotDrinkSizeArray = [SmallHotDrink, MediumHotDrink, LargHotDrink, XLargeHotDrink];

export { SmallHotDrink, MediumHotDrink, LargHotDrink, XLargeHotDrink, OrderedHotDrinkSizeArray };
